export default __webpack_public_path__ + "static/media/diamond-cut-3@3x.fc6d8bc9.png";